<template>
  <ProfileCard title="Остатки по услугам">
    <StateBlock v-if="state === 'loading'" state="loading" compact />
    <StateBlock v-else-if="state === 'error'" state="error" compact @retry="load" />
    <StateBlock v-else-if="!services.length" state="empty" compact title="Остатков по услугам пока нет" />
    <template v-else>
      <table class="manager-balances">
        <tr>
          <th>Услуга</th>
          <th class="manager-balances__num">Остаток</th>
        </tr>
        <tr v-for="item in services" :key="item.code">
          <td>{{ item.name }}</td>
          <td class="manager-balances__num" :class="{ 'error--text': item.amount < 0 }">
            <b>{{ item.amount }}</b>
            <v-btn v-if="enableAdd" icon x-small class="ml-2" title="Начислить" @click="$emit('add', item)">
              <v-icon small>mdi-pencil-outline</v-icon>
            </v-btn>
          </td>
        </tr>
        <tr class="manager-balances__total">
          <td>Всего</td>
          <td class="manager-balances__num"><b>{{ total }}</b></td>
        </tr>
      </table>
      <div class="caption grey--text text--darken-1 mt-2">Остаток на текущий момент. Обороты менеджера в сводке компании.</div>
    </template>
  </ProfileCard>
</template>

<script>
import api from '@/common/api';
import ProfileCard from '@/components/common/ProfileCard';
import StateBlock from '@/components/ui/StateBlock.vue';

// Остатки менеджера по услугам для карточки менеджера (вместо старого блока «Счетчики»).
// Запрашиваем напрямую, а не через users/counters: тот экшен пишет остатки в данные текущего пользователя.
export default {
  name: 'ManagerBalances',
  components: { ProfileCard, StateBlock },
  props: {
    userId: { type: [Number, String], required: true },
    // Кнопка начисления у строки услуги (у админа, при наличии права)
    enableAdd: { type: Boolean, default: false },
  },
  data() {
    return {
      items: [],
      state: 'loading', // loading | ok | error
    };
  },
  computed: {
    services() {
      return this.items
        .map((item) => ({ code: item.code, name: item.name, amount: Number(item.amount) || 0 }))
        .sort((a, b) => b.amount - a.amount);
    },
    total() {
      return this.services.reduce((sum, item) => sum + item.amount, 0);
    },
  },
  watch: {
    userId() {
      this.load();
    },
  },
  methods: {
    async load() {
      const requestedId = this.userId;
      this.state = 'loading';
      try {
        const response = await api.get(`/users/managers/${requestedId}/get-stock-balance/`);
        if (String(requestedId) !== String(this.userId)) return;
        if (!response || !Array.isArray(response.balance_detailed)) throw new Error('no balance');
        this.items = response.balance_detailed;
        this.state = 'ok';
      } catch (e) {
        this.state = 'error';
      }
    },
  },
  created() {
    this.load();
  },
};
</script>

<style scoped lang="scss">
.manager-balances {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;

  th {
    text-align: left;
    font-weight: 400;
    color: #757575;
    padding: 4px 0;
  }

  td {
    padding: 8px 0;
    border-top: 1px solid #f2f2f2;
  }

  &__num {
    text-align: right !important;
    white-space: nowrap;
  }

  &__total td {
    border-top: 2px solid #e0e0e0;
  }
}
</style>
